import { Row, Col, message } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { observer } from "mobx-react";
import { wopiViewerStore } from "Stores/WOPIViewerStore";
import { onlineViewerStore } from "Stores/OnlineViewerStore";
import { pdfViewerStore } from "Stores/PdfViewerStore";
import { I18N_NS } from "Config/i18n";
import { withTranslation, WithTranslation } from "react-i18next";
import type { ReactNode } from "react";

interface FileItemProps extends WithTranslation {
  file: API_FileDataEntity;
  tag?: ReactNode;
  onRemove: (id: number) => void;
}

export const FileItem = withTranslation(I18N_NS.PROJECT)(
  observer(({ t, file, onRemove, tag }: FileItemProps) => {
    const canView = file.viewers;
    const handleView = () => {
      const { viewers, id, name } = file;
      if (viewers.easyViewer) {
        pdfViewerStore.fetch(id, {
          fileName: name,
          canDownload: file.fileActions.download || file.fileActions.downloadWithWatermark,
        });
      } else if (viewers.office365) {
        wopiViewerStore.fetch(id, { fileName: name, edit: viewers.office365Edit });
      } else if (viewers.onlineViewer) {
        onlineViewerStore.fetch(id, { fileName: name });
      } else {
        message.error(t("The file can not be viewed by any file viewer."));
      }
    };

    return (
      <Row align="middle" justify="space-between" className="add-files-item">
        <Col span={20} className="add-files-item-title">
          {file.name}
          <div className="ml-5">{tag}</div>
        </Col>
        <Col>
          {canView && (
            <span onClick={handleView}>
              <FontAwesomeIcon icon={["fas", "eye"]} size="1x" fixedWidth={true} />
            </span>
          )}
          <span onClick={() => onRemove(file.id)}>
            <FontAwesomeIcon icon={["fas", "trash"]} size="1x" fixedWidth={true} />
          </span>
        </Col>
      </Row>
    );
  })
);
